import { ReactNode } from "react";
import { Stack } from "@mui/system";

export const CardWrapper = ({
  children,
  isCard,
  padding = "28px",
  backgroundColor,
  borderColor = "#D9D9D9",
}: {
  children: ReactNode;
  id?: string;
  isCard?: boolean;
  padding?: string;
  backgroundColor?: string;
  borderColor?: string;
}) => {
  if (!isCard) return <>{children}</>;

  return (
    <Stack
      gap="20px"
      sx={{
        padding,
        border: `1px solid ${borderColor}`,
        borderRadius: "12px",
        position: "relative",
        backgroundColor,
        overflow: "hidden",
      }}
    >
      {children}
    </Stack>
  );
};
